@charset "UTF-8";

/* src/app/modules/accounting/import/accounting-import.component.scss */
.ai-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 100%;
  box-sizing: border-box;
}
.ai-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.ai-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ai-header__icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ai-header__icon mat-icon {
  color: var(--cf-brand-dark);
  font-size: 26px;
  width: 26px;
  height: 26px;
  line-height: 1;
}
.ai-header__title {
  margin: 0 0 2px;
  font-size: 20px;
  font-weight: 700;
  color: #1a1d23;
}
.ai-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.ai-card {
  background: #fff;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 16px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}
.ai-card__head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.ai-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ai-card__icon mat-icon {
  color: #e3fd64;
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 1;
}
.ai-card__icon--blue {
  background: rgba(59, 130, 246, 0.1);
}
.ai-card__icon--blue mat-icon {
  color: #3b82f6;
}
.ai-card__title {
  margin: 0 0 3px;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}
.ai-card__sub {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}
.ai-steps {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ai-step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 13.5px;
  color: #334155;
  line-height: 1.55;
}
.ai-step__num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e3fd64;
  color: #1a1d23;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}
.ai-brand {
  color: var(--cf-brand-dark, #4d7a00);
}
.ai-must {
  color: var(--cf-brand-dark, #4d7a00);
}
.ai-info-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ai-info-item {
  font-size: 13.5px;
  color: #334155;
  line-height: 1.5;
  padding-left: 12px;
  border-left: 2px solid rgba(148, 163, 184, 0.25);
}
.ai-info-item--link {
  display: flex;
  align-items: center;
  gap: 6px;
  border-left-color: #e3fd64;
}
.ai-info-item--link mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 1;
  color: var(--cf-brand-dark, #4d7a00);
  flex-shrink: 0;
}
.ai-info-item--link a {
  color: var(--cf-brand-dark, #4d7a00);
  font-weight: 600;
  text-decoration: none;
}
.ai-info-item--link a:hover {
  text-decoration: underline;
}
.ai-upload-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.ai-select-field {
  min-width: 200px;
  max-width: 240px;
}
:host ::ng-deep .ai-select-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.ai-file-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 14px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  background: #f8fafc;
  transition: border-color 0.15s, background 0.15s;
  white-space: nowrap;
}
.ai-file-label:hover {
  border-color: #e3fd64;
  background: rgba(227, 253, 100, 0.04);
}
.ai-file-label mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 1;
  color: #64748b;
}
.ai-file-input {
  display: none;
}
.ai-card__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.ai-btn-primary {
  background: #e3fd64 !important;
  color: rgba(0, 0, 0, 0.85) !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}
.ai-btn-primary mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 1;
}
.ai-btn-secondary {
  border-radius: 10px !important;
  font-weight: 500 !important;
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  color: #475569 !important;
}
.ai-btn-secondary mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 1;
}
.ai-error-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 13px;
  color: #991b1b;
}
.ai-error-box mat-icon {
  color: #dc2626;
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 1px;
}
.ai-error-list {
  margin: 6px 0 0;
  padding-left: 16px;
}
.ai-error-list--scroll {
  max-height: 240px;
  overflow-y: auto;
}
.ai-table-wrap {
  overflow-x: auto;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 10px;
}
.ai-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}
.ai-th {
  padding: 10px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
  white-space: nowrap;
}
.ai-th--num {
  text-align: right;
}
.ai-td {
  padding: 8px 12px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  color: #1e293b;
  vertical-align: middle;
}
.ai-td--num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.ai-row--even {
  background: #fafbfc;
}
.ai-th--check,
.ai-td--check {
  width: 1%;
  text-align: center;
}
.ai-td--dup {
  min-width: 220px;
}
.ai-row--dup {
  background: #fffbeb;
}
.ai-row--skipped .ai-td:not(.ai-td--check):not(.ai-td--dup) {
  opacity: 0.45;
}
.ai-dup-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: #fef3c7;
  color: #92400e;
  white-space: nowrap;
}
.ai-dup-tag--sure {
  background: #fee2e2;
  color: #991b1b;
}
.ai-dup-reason {
  margin-top: 3px;
  font-size: 11.5px;
  color: #64748b;
}
.ai-dup-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 13px;
  color: #92400e;
}
.ai-dup-box mat-icon {
  color: #d97706;
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 1px;
}
.ai-progress-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ai-progress-label {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}
.ai-progress-count {
  font-weight: 500;
  color: #64748b;
  font-variant-numeric: tabular-nums;
}
.ai-progress-hint {
  font-size: 12px;
  color: #64748b;
}
.ai-progress-bar {
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}
.ai-progress-fill {
  height: 100%;
  background:
    linear-gradient(
      90deg,
      #e3fd64,
      #f59e0b);
  border-radius: 4px;
  transition: width 0.3s ease;
}
.ai-done-msg {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #16a34a;
}
.ai-done-msg mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 1;
  color: #16a34a;
}
@media (max-width: 767px) {
  .ai-page {
    padding: 12px;
    gap: 14px;
  }
  .ai-upload-row {
    flex-direction: column;
    align-items: stretch;
  }
  .ai-select-field {
    max-width: none;
  }
  .ai-table-wrap {
    overflow-x: auto;
  }
  .ai-table {
    min-width: 700px;
  }
}
/*# sourceMappingURL=accounting-import.component.css.map */
